export default __webpack_public_path__ + "static/media/menu.0a389b92.png";